import { render, staticRenderFns } from "./SchoolTypeList.vue?vue&type=template&id=7e1fdd0f&"
import script from "./SchoolTypeList.vue?vue&type=script&lang=js&"
export * from "./SchoolTypeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports